import { forwardRef } from "react";
import { Link } from "react-router-dom";
import crIcon from "@/assets/cr-logo-icon-white.svg";
import crWordmark from "@/assets/cipher-row-wordmark-white.svg";

interface BrandLogoProps {
  to?: string;
  className?: string;
  height?: string;
  /**
   * When true, renders the full "Cipher & Row" wordmark SVG (default).
   * When false, renders only the icon glyph (no text alongside).
   */
  showText?: boolean;
}

export const BrandLogo = forwardRef<HTMLDivElement, BrandLogoProps>(
  function BrandLogo({ to = "/", className = "", height = "h-9", showText = true }, ref) {
    const content = (
      <div ref={ref} className={`${height} flex items-center`}>
        <img
          src={showText ? crWordmark : crIcon}
          alt="Cipher & Row"
          loading="lazy"
          decoding="async"
          width={showText ? 160 : 40}
          height={40}
          className={`${height} w-auto object-contain`}
        />
      </div>
    );

    if (to) {
      return (
        <Link to={to} className={`flex items-center ${className}`} aria-label="Cipher & Row – home">
          {content}
        </Link>
      );
    }

    return <div className={`flex items-center ${className}`}>{content}</div>;
  }
);
